import { React, useEffect, useState } from "react";
import styled from "styled-components";
import { PRODUCT_TYPE_LIST, TAX_LIST } from "../../utilities/constants";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import FormikInput from "../Formik/FormikInput";
import FormikSelect from "../Formik/FormikSelect";
import { useSession } from "../../authentications/SessionContext";
import Translator from "./Translator";
import { primaryColor } from "../../utilities/colors";
import { useFormikContext } from "formik";
import { hasBgRendering } from "@fullcalendar/core/internal";

const GeneralContainer = styled.div`
  .form-control {
    display: block;
    width: 100%;
    // padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #ccc !important;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #f3f3f3 !important;
    border-radius: 13px !important;
  }
  .extra_price_text {
    width: 160px;
    max-with: 170px;
    font-sixe: 1vw;
    margin: 18px 0px 0px 10px;
    color: #ff5837;
    font-weight: 500;
    text-align: center;
  }
  .abx {
    width: 900px;
  }
`;

const GeneralComponent = ({
  disabled,
  productId,
  fieldName,
  fieldValue,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  setUpdatedData,
  taxList,
  categoriesList,
  handleCustomSearch,
  hasVariants,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { setFieldValue } = useFormikContext();
  const { isVTEX } = sessionInfo;
  useEffect(() => {
    setFieldValue("hasVariants", hasVariants);
  }, [hasVariants]);

  return (
    <GeneralContainer>
      <div className="row">
        {/* {isVTEX && (
          <div className="col-sm-6" style={{ position: "relative" }}>
            {!disabled && (
              <Translator
                productId={productId}
                color={primaryColor.primary}
                fieldName={fieldName}
                fieldValue={fieldValue}
                isCreateModalOpen={isCreateModalOpen}
                setIsCreateModalOpen={setIsCreateModalOpen}
                updatedData={updatedData}
                setUpdatedData={setUpdatedData}
              />
            )}
            <FormikInput
              disabled={disabled}
              name="description_sale"
              label={t["Description"]}
            />
          </div>
        )} */}
        {!isVTEX && (
          <div className="col-sm-6">
            <FormikSelect
              disabled={disabled}
              options={PRODUCT_TYPE_LIST}
              name="type"
              label={t["Product Type"]}
            />
          </div>
        )}

        {!isVTEX && (
          <div className="col-sm-6">
            <FormikSelect
              disabled={disabled}
              options={categoriesList}
              name="categ_id"
              label={t["Categories"]}
              handleSearch={({ ...args }) =>
                handleCustomSearch({ ...args, model: "product.category" })
              }
            />
          </div>
        )}
        <div className="col-sm-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="list_price"
            label={isVTEX ? t["List Price"] + "*" : t["Public Price"]}
          />
        </div>
        <div className="col-sm-6">
          <FormikSelect
            disabled={disabled}
            isMulti
            options={taxList}
            name="taxes_id"
            label={t["Customer Taxes"] + "*"}
          />
        </div>
        {!hasVariants && (
          <>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="standard_price"
                label={t["Product Price"] + "*"}
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                label={t["Barcode"] + "*"}
                name="barcode"
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                name="hs_code"
                label={t["HS Code"]}
              />
            </div>
          </>
        )}
        {/* </div> */}
        {/* <div className="row g-3"> */}
        {/* <div className="col-sm-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="weight"
            label={t["Weight"]}
          />
        </div> */}
        {isVTEX && (
          <div className="col-sm-6">
            <FormikInput
              disabled={disabled}
              name="vtex_product_id"
              label={t["Reference Code"] + "*"}
            />
          </div>
        )}
        {isVTEX && !hasVariants && (
          <>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="weight"
                label={isVTEX ? t["Weight (kgs)"] + "*" : t["Weight"]}
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="ProHeight"
                label={t["Height (cm)"] + "*"}
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="ProWidth"
                label={t["Width (cm)"] + "*"}
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="ProLength"
                label={t["Length (cm)"] + "*"}
              />
            </div>
          </>
        )}
        {!isVTEX && (
          <>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="weight"
                label={t["Weight"]}
              />
            </div>
            <div className="col-sm-6">
              <FormikInput
                disabled={disabled}
                type="number"
                name="volume"
                label={t["Volume"]}
              />
            </div>
          </>
        )}
        {/* </div> */}
        {/* <div className="row g-3"> */}
        <div className="col-sm-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="sale_delay"
            label={`${t["Preparation Time"]}`}
          />
        </div>
        {/* {!isVTEX && (
          <div className="col-sm-6">
            <FormikInput
              disabled={true}
              name="qty_available"
              label={t["Product Quantity"]}
            />
          </div>
        )} */}
      </div>

      {/* <div className="col-md-12 d-flex flex-column"></div>
      <FormikInput
        disabled={disabled}
        name="description"
        label={t["Description"]}
      /> */}
    </GeneralContainer>
  );
};

export default GeneralComponent;
